module.exports = __webpack_public_path__ + "fonts/sam-icons.f1e8b25.eot";